import axios from "../axiosPlugin.js";

export const getStockReportService = data => {
  return axios({
    url: "/api/report/stockReport",
    method: "get",
    data: {
      data,
    },
  });
};

export const getLogListService = data => {
  return axios({
    url: "/api/group/listForLog",
    method: "get",
    data: {
      data,
    },
  });
};


export const getOnlineBooking = data => {
  return axios({
    url: "/api/report/onlineSalesReport",
    method: "get",
    data: {
      data,
    },
  });
};

export const getOnlineReservationSalesReportService = data => {
  return axios({
    url: "/api/report/onlineReservationSalesReport",
    method: "get",
    data: {
      data,
    },
  });
};


export const getMembershipFeeSalesReportService = data => {
  return axios({
    url: "/api/cl/rpt/memberFeeRpt-list-online-brand",
    method: "get",
    data: {
      data,
    },
  });
};
